import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { colorPalette } from '@sharefiledev/antd-config';
import { Button, Flex, Input, theme } from 'antd';
import { ICON_SIZE } from '../../../constants';
import { t } from '../../../utils';

export const DropdownSettings = ({ component, handleUpdate }) => {
	const { token } = theme.useToken();
	return (
		<>
			{component?.selectOptions.map((option, index) => (
				<Flex key={index} gap={token.marginXS} style={{ marginTop: token.marginXS }}>
					<Input
						value={option}
						onChange={e => {
							const selectOptionsCopy = [...(component?.selectOptions || [])];
							selectOptionsCopy[index] = e.target.value;
							handleUpdate('selectOptions', selectOptionsCopy);
						}}
						aria-label={option}
					/>
					{component?.selectOptions.length > 2 && (
						<CloseCircleOutlined
							size={ICON_SIZE}
							onClick={() => {
								const selectOptionsCopy = [...(component?.selectOptions || [])];
								selectOptionsCopy.splice(index, 1);
								handleUpdate('selectOptions', selectOptionsCopy);
							}}
							data-testid="remove-checkbox-button"
							style={{ fontSize: '24px', color: colorPalette.neutral7 }}
						/>
					)}
				</Flex>
			))}
			<Button
				size="small"
				onClick={() =>
					handleUpdate(
						'selectOptions',
						!!component?.selectOptions
							? [
									...component?.selectOptions,
									`Option ${component?.selectOptions.length + 1}`,
							  ]
							: ['']
					)
				}
				style={{ marginTop: token.marginXS }}
			>
				{t('addOptionLabel')}
			</Button>
		</>
	);
};
